export const RISK_ITEM_ANIMAL = 'ANI';
export const RISK_ITEM_PERSON = 'PER';
export const RISK_ITEM_VEHICLE = 'VEH';
export const RISK_ITEM_PHYSICAL_PERSON = 'PPHY';

export const ID_PERPHY = 'ID_PERPHY';
export const NOM_PPHY = 'NOM_PPHY';
export const PRENOM_PPHY = 'PRENOM_PPHY';
export const DATENAISS_PPHY = 'DATENAISS_PPHY';
export const PP_PERPHY = 'PP_PERPHY';
export const DATEDEBCOUV_PPHY = 'DATEDEBCOUV_PPHY';
export const DATEFINCOUV_PPHY = 'DATEFINCOUV_PPHY';

export const ID = 'ID';
export const ID_VEHIC = 'ID_VEHIC';
export const TYPE_VEHIC = 'TYPE_VEHIC';
export const CATEG_VEHIC = 'CATEG_VEHIC';
export const ETAT_VEHIC = 'ETAT_VEHIC';
export const DATEACH_VEHIC = 'DATEACH_VEHIC';
export const ANCIRCUL_VEHIC = 'ANCIRCUL_VEHIC';
export const VALEUR_VEHIC = 'VALEUR_VEHIC';
export const PROP_VEHIC = 'PROP_VEHIC';
export const POWER_VEHIC = 'POWER_VEHIC';
export const OPT_VEHIC = 'OPT_VEHIC';
export const IDS_PERPHY = 'IDS_PERPHY';
export const MARQUE_VEHIC = 'MARQUE_VEHIC';
export const DATEDEBCOUV_VEHIC = 'DATEDEBCOUV_VEHIC';
export const DATEFINCOUV_VEHIC = 'DATEFINCOUV_VEHIC';
export const VP_VEHIC = 'VP_VEHIC';
